import { RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetRetailUnitParams = Static<typeof GetRetailUnitParamsSchema>;
export const GetRetailUnitParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetRetailUnitParamsSchema' }
);

export type GetRetailUnitResponse = Static<typeof GetRetailUnitResponseSchema>;
export const GetRetailUnitResponseSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema,
  },
  { additionalProperties: false, $id: 'GetRetailUnitResponseSchema' }
);
